import { resolveFeatureFlag } from "@swivl-mono/helpers";
import { FeatureFlagKey } from "@swivl-mono/types";

import AccountModel from "../../Models/Account/AccountModel";

/**
 * Studio-wide feature-flag check — the single way app code asks "is this flag
 * on?". Resolves the current account + org from AccountModel internally, so
 * callers only pass the flag.
 *
 * Snapshot read (not reactive): flags are stable within a session, and an org
 * switch full-reloads the page. Components that mount before the account loads
 * should already re-render on AccountModel state (e.g. NavDrawer subscribes via
 * AccountModel.useState).
 */
export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  const { account, member } = AccountModel.state;
  return resolveFeatureFlag(account, member?.org, flag);
}
